/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./statusSelector.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.statusSelector', deps)

  .directive('blStatusSelector', () => ({
    restrict: 'E',
    scope: {
      dpName: '<',
      dpStatus: '<',
      dpTicketId: '<',
      dpSentTimestamp: '<',
      accountStatementStatus: '<',
      dpNote: '<',
    },
    bindToController: true,
    template: require('./statusSelector.html'),
    controller: require('./statusSelectorCtrl.js'),
    controllerAs: 'vm',
  }));
